<template>
    <section class="assessmentSection questionsSection">
        <div class="pageContent">

            <section class="resolveCard"
                     v-if="system.advice.intrusion">
                <div class="trueAdviceCard-header">
                    <img src="/img/window-opened.png"
                         alt="Open Window"> Intrusion Protection
                </div>
                <div class="trueAdviceCard-advice">
                    Your {{ areaOfConcern.name }} windows are unprotected
                </div>
                <!-- <div class="trueAdviceCard-detail">
                    Smoke communicators are reliable and dependable. They call the fire department when you can’t.
                </div> -->
                <!-- Status Row -->
                <div class="trueAdviceCard-statusRow">
                    <div class="trueAdviceCard-statusRow-text">
                        Because these windows are accessible from the ground level, we recommend adding protection. If you are concerned when you are both home and away, or just when you’re at home, then the window sensors offer the best protection for your needs. If you are only concerned when you are away, then you can consider some of the alternatives.
                    </div>
                </div>
                <!-- End Status Row -->
            </section>

            <section class="resolveSection">
                <div class="resolveTitle">
                    <hr>
                    <span>Resolve the issue</span>
                </div>

                <div class="resolveMessage">
                    You have <span>no</span> window protection in your {{ areaOfConcern.name }}
                </div>
                <div class="resolveSolution">
                    Add window protection to resolve this issue.
                </div>

                <true-panel class="doorsInputPanel">
                    <AocEquipment />
                </true-panel>

                <button class="button full" @click="resolveArea" v-if="areaOfConcern.equipmentOptionChosen">
                    Resolve and return to Advice
                </button>

            </section>



        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AocEquipment from './areas-of-concern/AocEquipment.vue'
export default {
    data() {
        return {
            emptyAreaOfConcern: {}
        }
    },
    computed: {
        ...mapState(['system', 'equipment', 'lead', 'areaOfConcern']),

        ...mapGetters(['equipmentByName'])
    },
    methods: {
        ...mapActions([
            'updateSystem',
            'resolveAdvice',
            'updateAreaOfConcern',
            'editAreaOfConcern',
            'addAreaOfConcern',
            'save'
        ]),

        resolveArea() {
            this.editAreaOfConcern(this.areaOfConcern).then(() => {
                this.updateSystem()
                this.save()
                // Empty the local area of concern
                this.updateAreaOfConcern({})
                this.$router.push('/assessment/true-advice')
            })
        }
    },
    components: {
        AocEquipment
    },
    mounted() {
        this.emptyAreaOfConcern = {
            ...this.areaOfConcern
        }
        this.updateSystem()
        mixpanel.track("viewedTrueAdvice", {
            advice: 'Intrusion'
        })
    },

    updated() {
        if (!this.areaOfConcern.id) {
            // Get the id
            let aocId = this.$route.query.id
            // Set the AOC based on ID
            let area = this.lead.areasOfConcern.filter(
                aoc => aoc.id === aocId
            )[0]
            this.updateAreaOfConcern(area)
        }
    }
}
</script>

<style lang="css"></style>
